import axios from "axios";
import { api } from "./api_route";

export const createArbitrationProceedingAPI = async (proceedingData) => {
  try {
    const config = {};
    if (typeof FormData !== "undefined" && proceedingData instanceof FormData) {
      config.headers = { "Content-Type": "multipart/form-data" };
    }

    const response = await axios.post(
      `${api}/arbitrationProceedings/create`,
      proceedingData,
      config
    );
    return {
      data: response.data,
      status: response.status,
      success: true,
    };
  } catch (error) {
    return {
      data: null,
      error: error.response?.data?.message || error.message,
      status: error.response?.status,
      success: false,
    };
  }
};

export const updateArbitrationProceedingAPI = async (id, proceedingData) => {
  try {
    const config = {};
    if (typeof FormData !== "undefined" && proceedingData instanceof FormData) {
      config.headers = { "Content-Type": "multipart/form-data" };
    }

    const response = await axios.put(
      `${api}/arbitrationProceedings/update/${id}`,
      proceedingData,
      config
    );
    return {
      data: response.data,
      status: response.status,
      success: true,
    };
  } catch (error) {
    return {
      data: null,
      error: error.response?.data?.message || error.message,
      status: error.response?.status,
      success: false,
    };
  }
};

export const deleteArbitrationProceedingAPI = async (id) => {
  try {
    const response = await axios.delete(
      `${api}/arbitrationProceedings/delete/${id}`
    );
    return {
      data: response.data,
      status: response.status,
      success: true,
    };
  } catch (error) {
    return {
      data: null,
      error: error.response?.data?.message || error.message,
      status: error.response?.status,
      success: false,
    };
  }
};

export const getArbitrationProceedingsByCaseIDAPI = async (caseID) => {
  try {
    const response = await axios.get(
      `${api}/arbitrationProceedings/case/${caseID}`
    );
    return {
      data: response.data,
      status: response.status,
      success: true,
    };
  } catch (error) {
    return {
      data: null,
      error: error.response?.data?.message || error.message,
      status: error.response?.status,
      success: false,
    };
  }
};

export const getArbitrationProceedingAPI = async (id) => {
  try {
    const response = await axios.get(
      `${api}/arbitrationProceedings/get/${id}`
    );
    return {
      data: response.data,
      status: response.status,
      success: true,
    };
  } catch (error) {
    return {
      data: null,
      error: error.response?.data?.message || error.message,
      status: error.response?.status,
      success: false,
    };
  }
};
